<template>
    <span
        class="text-danger float-left mr-1"
        v-if="convenio.idSituacaoConvenio != 9"
    >
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Excluir Cronograma de Desembolso"
            @click.stop="confirmarExcluir(cronogramaDesembolso.idCronogramaDesembolso)"
        ></i>
    </span>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'

export default {
    props: {
        convenio: Object,
        cronogramaDesembolso: Object
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir(id) {
            this.$swal({
                title: 'Excluir',
                html:
                    'Deseja Excluir o Cronograma <strong>' +
                    this.cronogramaDesembolso.vcDescricao +
                    '</strong> ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluir(id)
                }
            })
        },

        excluir(id) {
            this.$store.dispatch('addRequest')
            ConveniosServicos.excluirCronogramaDesembolso(id).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Cronograma de Desembolso excluído com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizarLista')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },
    }
}
</script>
